import { NgModule } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { InputMaskModule } from 'primeng/inputmask';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TabViewModule } from 'primeng/tabview';
import { FileUploadModule } from 'primeng/fileupload';
import { ScrollTopModule } from 'primeng/scrolltop';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PaginatorModule } from 'primeng/paginator';
import { SkeletonModule } from 'primeng/skeleton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressBarModule } from 'primeng/progressbar';
import { TagModule } from 'primeng/tag';
@NgModule({
  declarations: [],
  imports: [
    InputTextModule,
    CheckboxModule,
    ButtonModule,
    SelectButtonModule,
    InputNumberModule,
    DropdownModule,
    CalendarModule,
    ToastModule,
    MessagesModule,
    InputMaskModule,
    RadioButtonModule,
    TabViewModule,
    FileUploadModule,
    ScrollTopModule,
    DialogModule,
    InputTextareaModule,
    ConfirmDialogModule,
    TooltipModule,
    MenuModule,
    ProgressSpinnerModule,
    PaginatorModule,
    SkeletonModule,
    OverlayPanelModule,
    ProgressBarModule,
    TagModule,
  ],
  exports: [
    InputTextModule,
    CheckboxModule,
    ButtonModule,
    SelectButtonModule,
    InputNumberModule,
    DropdownModule,
    CalendarModule,
    ToastModule,
    MessagesModule,
    TableModule,
    DividerModule,
    InputMaskModule,
    RadioButtonModule,
    TabViewModule,
    FileUploadModule,
    ScrollTopModule,
    DialogModule,
    InputTextareaModule,
    ConfirmDialogModule,
    TooltipModule,
    MenuModule,
    ProgressSpinnerModule,
    PaginatorModule,
    SkeletonModule,
    OverlayPanelModule,
    ProgressBarModule,
    TagModule,
  ],
  providers: [MessageService],
})
export class PrimengModule {}
